import type { IntlShape } from 'react-intl';
import type { KitAssetYouTube } from 'fym-shared/src/music24/addedAssets';
import { addedAssetsMessages } from './addedAssetsMessages';

/**
 * The views of a linked YouTube video, or null when we do not know them: the video is not on a
 * channel the artist connected, the read had no number, or the version is from before the field.
 * Pure.
 */
export function youtubeViewsOf(youtube: KitAssetYouTube | null | undefined): number | null {
  const views = youtube?.views;
  return typeof views === 'number' && Number.isFinite(views) && views >= 0 ? views : null;
}

/**
 * The badge of a linked YouTube video on the Kit slot (design music-video a5): "On YouTube · 48,210
 * views" with the views in the number format of the language, else "On YouTube". Pure.
 */
export function onYouTubeBadgeText(intl: IntlShape, youtube: KitAssetYouTube | null | undefined): string {
  const views = youtubeViewsOf(youtube);
  return views === null
    ? intl.formatMessage(addedAssetsMessages.onYouTube)
    : intl.formatMessage(addedAssetsMessages.onYouTubeViews, { count: views });
}
